// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5\\+31- {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  align-items: center;\n}\n\n  .VukgC {\n    cursor: pointer;\n  }\n\n  .IFc61 {\n    padding-left: 8px;\n  }\n\n  .qRbnO {\n      color: rgb(var(--color-cobalt-3))\n    }\n\n  .qRbnO:hover {\n        text-decoration: underline;\n      }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TextRenderer": "_5+31-",
	"TextRenderer__isClickable": "VukgC",
	"TextRenderer_text": "IFc61",
	"TextRenderer_text__isClickable": "qRbnO"
};
export default ___CSS_LOADER_EXPORT___;
